// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"edd803e4","667":"8d741c70"}[chunkId] + ".chunk.js";
};